import { getAtarText, ATAR_TOOL_MIN_SCORE } from "/src/helper/atar";

document.addEventListener("alpine:init", () => {
  const courseListFbAPI =
    "https://latr-search.funnelback.squiz.cloud/s/search.json?collection=latr~sp-atar-wizard&num_ranks=1000&query=!FunDoesNotExist:PadreNull";

  let _preSelectAtar;
  if (!isNaN(ATAR_JOURNEY_DATA?.courseListDefault?.preSelectAtar)) {
    _preSelectAtar = ATAR_JOURNEY_DATA.courseListDefault.preSelectAtar;
  }

  Alpine.data("findCourses", function () {
    return {
      courseListFilters: this.$customPersist({
        disciplines: [],
        locations: [],
      }).as("atarJourney_courseListFilters"),

      showFilters: false,

      numCourseDisplayed: 10,
      stepCourseDisplayed: 10,
      userAdjustedATAR: _preSelectAtar ?? 99.95,
      getUserAdjustedAtarText(val) {
        return getAtarText(val ?? this.userAdjustedATAR);
      },

      defaultShowCourseList:
        ATAR_JOURNEY_DATA && ATAR_JOURNEY_DATA.courseListDefault
          ? !!ATAR_JOURNEY_DATA.courseListDefault.show
          : true,

      defaultShowHeading:
        ATAR_JOURNEY_DATA && ATAR_JOURNEY_DATA.courseListDefault
          ? !!ATAR_JOURNEY_DATA.courseListDefault.showHeading
          : true,

      findATARHeading:
        ATAR_JOURNEY_DATA && ATAR_JOURNEY_DATA.courseListDefault
          ? !!ATAR_JOURNEY_DATA.courseListDefault.showFindATARHeading
          : true,

      defaultStoreATARValueKey:
        ATAR_JOURNEY_DATA &&
        ATAR_JOURNEY_DATA.courseListDefault &&
        ATAR_JOURNEY_DATA.courseListDefault.storeATARValueKey
          ? ATAR_JOURNEY_DATA.courseListDefault.storeATARValueKey
          : "adjustedATAR",

      pathwayToolURL:
        ATAR_JOURNEY_DATA &&
        ATAR_JOURNEY_DATA.courseListDefault &&
        ATAR_JOURNEY_DATA.courseListDefault.pathwayToolURL
          ? ATAR_JOURNEY_DATA.courseListDefault.pathwayToolURL
          : "",

      locationFilters: {
        BU: "Melbourne",
        WO: "Albury-Wodonga",
        BE: "Bendigo",
        // 'CI': 'City',
        MI: "Mildura",
        SH: "Shepparton",
        SY: "Sydney",
        ON: "Online",
        OT: "Other",
      },

      disciplineFilters: [
        "Arts, social sciences and communications",
        "Business and commerce",
        "Criminology",
        "Education and teaching",
        "Engineering",
        "Health",
        "Information technology",
        "Law",
        "Science",
      ],

      parsedCourseList: [],
      sortedCourseList: [],

      courseListDisplayNum: 10,

      listSortCol: "",
      listSortDir: "default",
      listSortDirNextState: {
        default: "asc",
        asc: "dsc",
        dsc: "default",
      },
      listSortIconMap: {
        default: "ds-icon-code",
        asc: "ds-icon-chevron-down",
        dsc: "ds-icon-chevron-up",
      },

      initialised: false,

      init() {
        // select search API
        let _timeoutIDRefreshCourses;
        let _timeoutIdUpdateUi;

        this.$nextTick(() => {
          // after all component initialised (apline:init event callcacked), i.e. Alpine.store('atarCalculator') is ready
          this.$nextTick(() => {
            // wait for Alpine.store('atarCalculatorPersistProxy') $watch() setup
            if (_preSelectAtar >= 0 && _preSelectAtar <= 99.95) {
              Alpine.store("atarCalculator").adjustedATAR = _preSelectAtar;
              Alpine.store("atarCalculator")[this.defaultStoreATARValueKey] =
                _preSelectAtar;
              // document
              //   .querySelector(".find-course")
              //   .scrollIntoView({ behavior: "smooth", block: "start" });
            }
          });
        });

        this.$watch(
          `$store.atarCalculator.${this.defaultStoreATARValueKey}`,
          (newVal) => {
            this.userAdjustedATAR = newVal;
            clearTimeout(_timeoutIDRefreshCourses);
            _timeoutIDRefreshCourses = setTimeout(
              () => this.refreshCourseList(),
              500
            );

            clearTimeout(_timeoutIdUpdateUi);
            _timeoutIdUpdateUi = setTimeout(() => setBubble(range, bubble), 0);
          }
        );

        Object.keys(this.courseListFilters).forEach((group) => {
          this.$watch("courseListFilters." + group, (newVal) => {
            // console.log(`courseListFilters ${group} updated`, newVal)
            clearTimeout(_timeoutIDRefreshCourses);
            _timeoutIDRefreshCourses = setTimeout(
              () => this.refreshCourseList(),
              500
            );
          });
        });

        this.refreshCourseList().then(() => (this.initialised = true));
      },

      scrollToFilter(destination) {
        this.$nextTick(() => {
          document
            .querySelector(destination)
            .scrollIntoView({ behavior: "smooth", block: "center" });
        });
      },

      slugify(content) {
        return content.toLowerCase().replace(",", "").replace(/\s+/g, "-");
      },

      toggleFilters() {
        this.showFilters = !this.showFilters;

        if (this.showFilters) {
          document.body.classList.add("overlay-open");
        } else {
          document.body.classList.remove("overlay-open");
        }
      },

      clearFilters: function () {
        Object.keys(this.courseListFilters).forEach((group) => {
          this.courseListFilters[group] = [];
        });

        this.toggleFilters();
      },

      refreshCourseList() {
        const qs = new URLSearchParams();

        let _expectDuplicateResults = true;

        if (this.courseListFilters.disciplines.length) {
          _expectDuplicateResults = false;

          qs.set(
            "meta_D_or",
            this.courseListFilters.disciplines
              .map((v) => encodeURIComponent(v))
              .join(" ")
          );
        }

        if (this.courseListFilters.locations.length) {
          qs.set(
            "meta_L_or",
            this.courseListFilters.locations
              .map((v) => encodeURIComponent(v))
              .join(" ")
          );
        }

        if (typeof this.userAdjustedATAR === "number") {
          qs.set("le_MO", this.userAdjustedATAR);
        }

        const apiURL =
          courseListFbAPI + (qs.toString() ? "&" + qs.toString() : "");

        // console.log('qs', qs.toString(), 'apiURL', apiURL)

        this.fetchingData = true;
        return fetch(apiURL)
          .then((resp) => resp.json())
          .then((data) =>
            this._handleLoadCourses(data, _expectDuplicateResults)
          )
          .catch((err) => {
            console.log("err", apiURL, err);
          })
          .then((data) => (this.fetchingData = false));
      },

      _handleLoadCourses(data, expectDuplicateReuslts) {
        const results = data.response.resultPacket.results;

        // get tier 1 result
        let _fullyMatchResults = results.filter(function (row) {
          return row.tier === 1;
        });

        if (expectDuplicateReuslts) {
          var _tmp = {};
          _fullyMatchResults = _fullyMatchResults.filter(function (row) {
            var _key = row.listMetadata.PU[0] + "/" + row.listMetadata.L[0];

            if (_tmp[_key]) {
              return false;
            }

            _tmp[_key] = true;
            return true;
          });
        }

        if (_fullyMatchResults.length === 0) {
          this.parsedCourseList = [];
          this.sortedCourseList = [];

          return;
        }

        let _arr = [];

        let i;

        for (i = 0; i < _fullyMatchResults.length; i++) {
          const row = _fullyMatchResults[i];

          const _locCode = row.listMetadata.L[0].trim();
          const _locName = this.locationFilters[_locCode]
            ? this.locationFilters[_locCode].trim()
            : "";

          const _isDiploma = row.listMetadata.DC[0] === "1";
          const _hasAtarPrerequisiteRequirement =
            row.listMetadata.ARR[0] === "1";

          const _minSelectionRank = row.listMetadata.MOD
            ? row.listMetadata.MOD[0].trim()
            : "";

          // _minSelectionRankLabel is the display label
          let _minSelectionRankLabel = _minSelectionRank;
          if (_isDiploma && !_hasAtarPrerequisiteRequirement) {
            _minSelectionRankLabel = "No ATAR required";
          }
          if (!_minSelectionRankLabel) {
            _minSelectionRankLabel = "View on course page";
          }

          // _minSelectionRankVal is the value for sorting
          let _minSelectionRankVal = parseFloat(row.listMetadata.MO[0]);
          if (_minSelectionRankLabel === "View on course page") {
            _minSelectionRankVal = -1;
          } else if (_minSelectionRankLabel === "No ATAR required") {
            _minSelectionRankVal = -100;
          } else if (isNaN(_minSelectionRankVal) || _minSelectionRankVal == 0) {
            if (_minSelectionRank === "N/A" || _minSelectionRank === "NA") {
              _minSelectionRankVal = -10;
            } else if (
              _minSelectionRank === "N/P" ||
              _minSelectionRank === "NP"
            ) {
              _minSelectionRankVal = -11;
            } else if (
              _minSelectionRank === "N/C" ||
              _minSelectionRank === "NC"
            ) {
              _minSelectionRankVal = -12;
            } else {
              _minSelectionRankVal = -50;
            }
          }

          _arr.push({
            title: row.listMetadata.AT[0].trim(),
            url: row.listMetadata.PU[0].trim(),
            urlPath: row.listMetadata.UP[0].trim(),
            minSelectionRankVal: _minSelectionRankVal,
            minSelectionRank: _minSelectionRank,
            discipline: row.listMetadata.D[0].trim(),
            locationCode: _locCode,
            locationName: _locName,
            isBachelorCourse: row.listMetadata.BC[0] === "1",
            isDiplomaCourse: _isDiploma,
            hasAtarPrerequisiteRequirement: _hasAtarPrerequisiteRequirement,
            _minSelectionRankLabel: _minSelectionRankLabel,
          });
        }

        this.parsedCourseList = _arr;

        this._sortCourseList();
      },

      _sortCourseList() {
        let _arr = this.parsedCourseList.slice(0);

        function _sortLoc(a, b) {
          if (a[0] === "BU") {
            return -1;
          } else if (b[0] === "BU") {
            return 1;
          } else {
            return a[1].localeCompare(b[1]);
          }
        }

        // default sorting behaviour
        const _defaultSort = (a, b) => {
          if (this.listSortDir === "dsc") {
            [b, a] = [a, b];
          }

          if (a["minSelectionRankVal"] !== b["minSelectionRankVal"]) {
            return a["minSelectionRankVal"] > b["minSelectionRankVal"] ? -1 : 1;
          } else if (
            a["minSelectionRankVal"] === 0 &&
            a["minSelectionRank"] !== b["minSelectionRank"]
          ) {
            // both record has 0 ATAR number value and their display value (NA/NC etc) are different, then we can sort by display value
            return a["minSelectionRank"].localeCompare(b["minSelectionRank"]);
          }

          if (a["title"] !== b["title"]) {
            return a["title"].localeCompare(b["title"]);
          }

          return _sortLoc(
            [a["locationCode"], a["locationName"]],
            [b["locationCode"], b["locationName"]]
          );
        };

        const _sortByValue = (a, b) => {
          var aVal = a[this.listSortCol],
            bVal = b[this.listSortCol];

          if (this.listSortCol === "minSelectionRankVal") {
            // sorting in 'reverse' order against default sorting on ATAR as default sort order for ATAR is descending
            return _defaultSort(b, a);
          }

          if (aVal === bVal) {
            return 0;
          }

          if (this.listSortDir === "asc") {
            return aVal > bVal ? 1 : -1;
          } else {
            return aVal > bVal ? -1 : 1;
          }
        };

        _arr = _arr.sort(
          this.listSortDir === "default" ? _defaultSort : _sortByValue
        );

        this.sortedCourseList = _arr;
      },

      toggleSort(sortCol, order) {
        this.listSortDir = order;
        this.listSortCol = sortCol;
        this._sortCourseList();
      },

      getSortIcon() {
        const currentSortCol = this.$el.parentNode.getAttribute("data-sort-by");

        if (this.listSortCol != currentSortCol) {
          return "ds-icon-code";
        }

        return this.listSortIconMap[this.listSortDir];
      },

      setFACDefaults(courseData) {
        console.log("courseData", courseData);

        if (courseData.locationCode) {
          localStorage.setItem(
            "prospectiveLocationTmp",
            courseData.locationCode
          );
        } else {
          localStorage.removeItem("prospectiveLocationTmp");
        }

        // user would see domestic version
        localStorage.setItem("studentType", "D");
      },
      showSortBy: false,
    };
  });

  // setup test value
  // setTimeout(() => {Alpine.store('atarCalculator').adjustedATAR = 70})

  // https://codepen.io/chriscoyier/pen/eYNQyPe
  const range = document.querySelector('input[type="range"]');
  var bubble = document.querySelector(".atar-score-bubble");

  setBubble(range, bubble);

  range.addEventListener("input", () => {
    setBubble(range, bubble);
  });

  function setBubble(range, bubble) {
    const val = range.value;
    const min = range.min ? range.min : ATAR_TOOL_MIN_SCORE;
    const max = range.max ? range.max : 100;
    var newVal = Number((val - min) / (max - min));
    bubble.innerHTML = getAtarText(val);

    const leftSpaceOffset = 26;
    bubble.style.left = `calc(${leftSpaceOffset}px + (100% - ${
      leftSpaceOffset * 2
    }px) * ${newVal})`;
  }
});
